var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{staticClass:"v-input--checkbox__select-products",attrs:{"ripple":false,"input-value":_vm.value,"hide-details":""},on:{"change":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }